import React from "react";
import signImg from "../../assets/images/login-signup/signup.png";
import logoSign from "../../assets/images/login-signup/loginLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";

let SignupSchema = object({
  name: string().required("Name is Required"),
  email: string()
    .email("Invalid email address (must include '@')")
    .required("Email is required"),
  number: string()
    .matches(/^\d{10}$/, "Phone Number must be 10 digits")
    .required("Phone number is Required"),
  password: string().required("Password is Required"),
});
export function Signup() {
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      number: "",
      password: "",
      userType: "USER",
    },
    validationSchema: SignupSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const formattedValues = {
          ...values,
        };

        const { data } = await axiosInstance.post("/signup", formattedValues);

        if (data.status === 200) {
          toast.success(data.message || "Signup Successfully!");
          resetForm();
          setTimeout(() => {
            navigate("/login");
          }, 3000);
        } else {
          toast.error("Something went wrong, please try again!");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        toast.error("Submission failed! Please try again.");
      }
    },
  });
  return (
    <>
      <ToastContainer />
      <div className="signup-container container">
        <div className="signup-subcontainer">
          <div className="signup-left">
            <div className="signup-logo">
              {" "}
              <img src={logoSign} />
            </div>
            <div className="signup-Img">
              <img src={signImg} />
            </div>
          </div>
          <div className="signup-right">
            <form onSubmit={formik.handleSubmit}>
              <div className="signup-form">
                <div className="signupForm-title">Create your account</div>
                <div className="signRow">
                  <div className="signup-field">
                    <label for="name">Full Name</label>
                    <input
                      type="text"
                      placeholder="Enter your Name"
                      id="name"
                      onChange={formik.handleChange}
                    ></input>
                    {formik.touched.name && formik.errors.name && (
                      <div className="formError">{formik.errors.name}</div>
                    )}
                  </div>
                  <div className="signup-field">
                    <label for="email">Email Address</label>
                    <input
                      type="text"
                      placeholder="Enter your email address"
                      id="email"
                      onChange={formik.handleChange}
                    ></input>
                    {formik.touched.email && formik.errors.email && (
                      <div className="formError">{formik.errors.email}</div>
                    )}
                  </div>
                </div>
                <div className="signRow">
                  <div className="signup-field">
                    <label for="number">Phone Number</label>
                    <input
                      type="text"
                      placeholder="Enter your phone number"
                      id="number"
                      onChange={formik.handleChange}
                    ></input>
                    {formik.touched.number && formik.errors.number && (
                      <div className="formError">{formik.errors.number}</div>
                    )}
                  </div>
                  <div className="signup-field">
                    <label for="password">Password</label>
                    <input
                      type="password"
                      placeholder="Enter your password"
                      id="password"
                      onChange={formik.handleChange}
                    ></input>
                    {formik.touched.password && formik.errors.password && (
                      <div className="formError">{formik.errors.password}</div>
                    )}
                  </div>
                </div>
                <div className="btnSignForm">
                  <button>Sign Up</button>
                </div>
                <div className="txtAlready">
                  <span style={{ color: "#090657" }}>
                    Already have an account? 
                  </span>
                  <span className="login-here">
                    <Link to="/login">Login here</Link>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
